module.exports = System.import('@enersis/gp-components/number-formatting');